import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import expandIcon from "../../assets/images/questions/reader_expand.svg";
import fullscreenIcon from "../../assets/images/questions/reader_fullscreen.svg";
import "./PaperPreview.css";

export default function PaperPreview({ paper, onOpenFullscreen }) {
    const t = useSelector(selectTranslations)
    const [expanded, setExpanded] = useState(false)

    useEffect(() => setExpanded(false), [paper])

    const html = paper?.replaceAll("\n", '<br />')?.replaceAll("$$", "$")

    return (
        <div className="paper_preview_wrapper">
            <div className={"reader_preview" + (expanded ? " expanded" : "")} onClick={() => !expanded && setExpanded(true)}>
                <p style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{ __html: html }} />
            </div>
            {expanded && onOpenFullscreen ?
                <button type="button" className="paper_preview_fullscreen" onClick={onOpenFullscreen} aria-label={t.question.open_fullscreen} title={t.question.open_fullscreen}>
                    <img src={fullscreenIcon} alt="" />
                </button>
            : null}
            <button type="button" className="paper_preview_toggle" onClick={() => setExpanded(!expanded)} aria-label={expanded ? t.question.read_less : t.question.read_more}>
                <img src={expandIcon} alt="" className={expanded ? "rotated" : ""} />
            </button>
        </div>
    )
}
